"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const cosmos_1 = require("components/cosmos");
const users_cosmos_svg_1 = require("components/svg/icons/users-cosmos.svg");
const tooltip_1 = require("components/tooltip");
const translate_1 = require("components/translate");
const useRandom_1 = __importDefault(require("hooks/useRandom"));
const classManager_1 = require("modules/classManager");
const content_1 = require("modules/content");
const ui_1 = require("modules/ui");
const ClassesModuleTooltip = ({ isLast, classHashIds, productId, t }) => {
    const [classesList, setClassesList] = react_1.default.useState([]);
    const [isClassesLoaded, setIsClassesLoaded] = react_1.default.useState(false);
    const tooltipContainerId = (0, useRandom_1.default)();
    const classNameTooltip = (0, classnames_1.default)('classes--tooltip', {
        'tooltip__portal--bellow': !isLast,
        'tooltip__portal--above': isLast
    });
    const onClickOrMouseEnter = () => {
        const fetchClasses = async () => {
            try {
                const response = await content_1.ClassesService.fetchClasses(classHashIds, productId);
                setClassesList(response);
                setIsClassesLoaded(true);
            }
            catch (error) {
                ui_1.UiService.handleError(error);
            }
        };
        fetchClasses();
    };
    const renderClassList = () => {
        if (!isClassesLoaded) {
            return (0, jsx_runtime_1.jsx)(cosmos_1.Loading, { center: true });
        }
        return ((0, jsx_runtime_1.jsx)("ul", { children: (classesList === null || classesList === void 0 ? void 0 : classesList.length) > 0 ? (classesList.map((classItem) => ((0, jsx_runtime_1.jsx)("li", { "data-test": "class-label", children: classManager_1.DefaultClassUtil.getName(classItem.name) }, classItem.hashId)))) : ((0, jsx_runtime_1.jsx)("li", { "data-test": "warning-message", children: t('content_list.total_classes_none') })) }));
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "module-flags-list _ml-2", children: (0, jsx_runtime_1.jsxs)("button", { className: "module-pages-flag module-pages-flag--classes", id: tooltipContainerId, onMouseEnter: onClickOrMouseEnter, onClick: onClickOrMouseEnter, "data-test": "class-container", "aria-label": t('general.classes'), children: [(0, jsx_runtime_1.jsx)(users_cosmos_svg_1.ReactComponent, {}), (0, jsx_runtime_1.jsx)(tooltip_1.TooltipPortal, { arrowPos: "right", parentId: tooltipContainerId, className: classNameTooltip, children: renderClassList() })] }) }));
};
exports.default = (0, translate_1.translate)()(ClassesModuleTooltip);
